<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Buttons" pageTitle="Buttons" />
            <ButtonsContent />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import ButtonsContent from '../Buttons/ButtonsContent'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'ButtonsPage',
    components: {
        MainHeader,
        PageTitle,
        ButtonsContent,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>